import DisplayCollection from './DisplayCollection'

export default DisplayCollection
